import React, { CSSProperties } from 'react';

import { t } from 'i18next';

import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';

import './DeleteModal.scoped.scss';

interface Props {
  children?: React.ReactNode;
  style?: CSSProperties;
  openModal?: boolean;
  handleModal?: () => void;
  handleCloseModal: () => void;
  handleDelete: () => void;
  onInputChange?: (id: string, mark: number) => void;
  responding?: any;
  generalMessage?: string;
  location?: string;
  numberOfLeafs?: number;
  type?: any;
  chapterAssignmentsLength?: number;
  shouldRenderFooter?: boolean;
  shouldRenderAreYouSure?: boolean;
  shouldDisplayMessage?: boolean;
}

const DeleteModal: React.FC<Props> = ({
  openModal,
  handleModal,
  responding,
  handleCloseModal,
  handleDelete,
  generalMessage,
  shouldRenderFooter = true,
  shouldRenderAreYouSure = true,
  shouldDisplayMessage = false,
}) => {
  const time = responding?.created_at?.split('T')[1];

  const deleteConfirmed = () => {
    handleDelete();
    handleCloseModal();
  };

  const renderFooter = () => {
    return (
      <div className="delete-modal-footer">
        <Button
          onClick={handleCloseModal}
          outlined
          round
          style={{
            background: '#DDE7F4 0% 0% no-repeat padding-box',
            height: 30,
            fontSize: 14,
            paddingLeft: '15px',
            paddingRight: '15px',
            color: '#16243C',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
          }}
        >
          <div className="inside-button">{t('common:cancel')}</div>
        </Button>

        <Button
          onClick={deleteConfirmed}
          outlined
          round
          style={{
            background: '#D53A3A 0% 0% no-repeat padding-box',
            height: 30,
            fontSize: 14,
            paddingLeft: '15px',
            paddingRight: '15px',
            color: '#fff',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '10px',
          }}
        >
          <div className="inside-button">
            {/* <CloseIcon className="button-img" /> */}
            {t('common:delete')}
          </div>
        </Button>
      </div>
    );
  };

  const messagePreview = () => {
    return (
      <div className="delete-modal-mssg">
        <div className="mssg-left">
          <img src={responding?.user?.avatar_url} alt="" className="avatar" />
        </div>
        <div className="mssg-right">
          <div className="top">
            <span className="username">
              {`${responding?.user?.first_name} ${responding?.user?.last_name}`}
            </span>
            <span className="date">{time?.split(':').slice(0, 2).join(':')}</span>
          </div>
          <div className="bottom">
            {responding?.body?.length > 15 && (
              <p className="body">{responding?.body?.substring(0, 15)}...</p>
            )}
            {responding?.body?.length < 15 && <p className="body">{responding?.body}</p>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal open={openModal} onClose={handleModal} title={t('chat:Delete_message')} padding={0}>
      <div className="delete-modal-container">
        {shouldRenderAreYouSure && <p>{t('common:Are_you_sure_to_delete')}</p>}
        <h3 className="general-message-container">{generalMessage}</h3>
        {shouldDisplayMessage && messagePreview()}
      </div>
      {shouldRenderFooter && renderFooter()}
    </Modal>
  );
};

export default DeleteModal;
